(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled svih računa",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Stanje po računu",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Transakcije",
        "accPdfStatements":"Pdf izvod",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi originalni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtijevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum odobrenja",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Datum zadnje promjene",
        "accAlreadySpent":"Dospeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvarnja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospeća",
        "accCurrentBalance":"Tekuće stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Datum zadnje promjene",
        "accBalanceDateLastChanged":"Poslednja promena",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlašćena lica",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj rata",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
        "activateCard": "Aktiviraj karticu",
        "blockCardRequest": "Blok zahtjev poslan",
        "unblockCardRequest": "Odblokiraj zahtjev poslan",
        "activationCardRequest": "Aktiviraj zahtjev poslan",
        "accDueAmount": "Ukupan dospeli dug",
        "accMatureInterest":"Kamata",
        "accNewEbook": "Nova eknjižica",
        "closeEbook": "Zatvaranje eknjižice",
        "accPaymInQue": "Broj nerealizovanih čekova",
        "accReservedAmount": "Rezervisani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospele obaveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj plaćenih rata",
        "accNotMatureCapital": "Nedospela glavnica",
        "accNewDebitDate": "Datum iduće obaveze",
        "title": "Informacija",
        "message":"Molimo Vas nazovite Kontakt centar na besplatni broj telefona 0800 303 303 ili na +381 11 222 6000 za pozive iz inozemstva.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eknjižicu",
        "Blocked":"Blokiran",
        "transDivisionBtn1": "Podela",
        "transDivisionBtn2": "transakcija",
      },
      merchant: {
        'address': 'Adresa',
        'contact': 'Kontakt',
        'website': 'Website',
        'location': 'Lokacija',
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu ",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povraćaj",
        "ibanFrom": "IBAN platioca",
        "accountFrom": "Račun platioca",
        "accountTo": "Račun primaoca",
        "referenceNumber":"Referentni broj",
        "creditorName": "Uplatilac",
        "debitorName": "Primalac",
        "creditorAddress": "Adresa uplatioca",
        "debitorAddress": "Adresa primaoca",
        "date":"Datum transakcije",
        "MCC": "MCC",
        "POSReference": "Referenca transakcije na prodajnom mjestu",
        "POSIPS": "POS_IPS"
      },
      ebook: {
        "header": "Zahtjev za otvaranje eknjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eknjižice",
        "termsAndConditions": "Prihvaćam opće uvjete poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Obriši",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eknjižice je obavezan!",
        "createEbook": "Kreiraj eknjižicu",
        "successfullRequest": "Uspješno ste kreirali eknjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "eKnjižica zahtjevi",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahteva za eknjižice",
        "showAllRequests": "Prikaži zahteve za sve račune",
        "ebookNumber": "Račun eknjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eknjižice",
        account: "Broj eknjižice",
        accountName: "Naziv eknjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novi eSaving račun"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja i eknjižica",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled štednih računa"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "Gotovinske isplate stranog / domaćeg efektivnog novca veće od 5.001,00 EUR / 35.001,00 HRK potrebno je najaviti 3 dana unaprijed pisanim zahtjevom putem HYPOneta.",
        infoNote2: "U slučaju nepodizanja gotovine Banka će teretiti Vaš račun za iznos naknade prema važećoj tarifi Banke.",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije",
        "noData": "Nema dostupnih rezervacija",
        "type": "Type",
        "originAmount": "Iznos u originalnoj valuti"
      },
      transactionDivision: {
        "title": "Podeli transakciju",
        "creationDate": "Datum kreiranja zahteva",
        "fullName": "Ime i prezime",
        "jmbg": "JMBG",
        "transactionDate": "Datum transakcije",
        "amount": "Iznos",
        "numOfInstallment": "Izaberite broj rata",
        "sellingPlace": "Naziv prodajnog mesta",
        "lastDigits": "Zadnja 4 broja sa kartice",
        "sellingPlaceError": "Naziv prodajnog mesta je obavezno!",
        "lastDigitsError": "Zadnja 4 broja sa kartice su obavezna!",
        "lastDigitsLengthError": "Broj mora imati 4 cifre!",
        "yourTransDiv": "Zahtjevi za podjelu transakcija",
        "transLocation": "Prodajno mjesto",
        "cardNumber": "Broj kartice",
        "status": "Status",
        "creatorName": "Kreator",
        "installmentNumber": "Broj rata",
        "cancel": "Odustani",
        "confirm": "Potvrdi",
        "reservationNumber": "Broj rezervacije",
        "Opened": "Kreiran",
        "installmentInfo": "Broj rata",
        "successMessage":"Uspešno ste podneli zahtev za podelu na rate.",
        "finalStepStatus":"Status:",
        "finalStepId":"ID transakcije:",
        "finalStepSentForProcessing":"Zahtev za podelu je prosleđen u Banku na dalju odbradu.",
        "finalStepSentForProcessingV2":"Podela na rate se tarifira u skladu sa Tarifnikom.",
        "makeAnotherPayment":"Kreiraj novi nalog",
        "backToTransactions":"Nazad na pregled transakcija",
        "Rejected":"Odbijen",
        "WaitingQueue":"Na čekanju",
        "Processed":"Uspješno obrađen",
        "InProcessing":"U obradi",
        "infoIfLastDay": "Podelu na rate poslednjeg dana u mesecu možete izvršiti pozivom na broj telefona 0800 303 303, radnim danom i subotom od 08 do 20 i nedeljom od 09 do 14 časova. Vaša Addiko Banka"
      }
    };

    $translateProvider
      .translations('sr', data);

  }
}());
